import { ajax } from 'cadenza/api-client/api';
import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';
import { logger } from 'cadenza/utils/logging';
import h from 'hyperscript';
import './apply-filter-button.css';
import { errorAlert, confirm } from 'cadenza/alert';

import i18n from './report-scheduler-administration.properties';

const ELEMENT_NAME = 'd-report-schedule-apply-filter-button';

class ApplyFilterButton extends HTMLElement {

  connectedCallback () {
    const urlParams = new URLSearchParams(location.search);
    const jobScheduleId = urlParams.get('jobSchedule');
    const jobScheduleVersion = urlParams.get('version');

    if (!jobScheduleId || !jobScheduleVersion) {
      return;
    }

    const button = h(`button.button.button-primary.${ELEMENT_NAME}`, {
      type: 'button',
      onclick: () => applyFilter(jobScheduleId, jobScheduleVersion)
    }, i18n('apply-filter.title'));

    this.parentNode.replaceChild(button, this);
  }

}

function applyFilter (jobScheduleId, jobScheduleVersion) {
  ajax(`/jobSchedules/${jobScheduleId};version=${jobScheduleVersion}/filters` + location.search, { method: 'PUT' })
    .then(goBackToAdminPanel)
    .catch(error => {
      logger.error(`Failed to update filters for job schedule ${jobScheduleId}`, error);
      if (error.status === 409) {
        confirm(i18n('apply-filter.error.title'), i18n('apply-filter.error.message.409'), {
          type: 'info',
          submit: i18n('apply-filter.error.409.submit'),
          cancel: false
        }).finally(goBackToAdminPanel);
      } else {
        errorAlert(i18n('apply-filter.error.title'), i18n('apply-filter.error.message')).finally(goBackToAdminPanel);
      }
    });

  function goBackToAdminPanel () {
    location.href = cadenzaUrl('/pages/processingChain/report/administration/index.xhtml?jobSchedule=' + jobScheduleId);
  }
}

customElements.define(ELEMENT_NAME, ApplyFilterButton);
